import { z } from 'zod';

export const statisticsSchema = z.object({
  start_date: z.string(),
  end_date: z.string(),
  metrics: z.string(),
  vehicle_id: z.string().optional(),
});

export type Statistics = z.infer<typeof statisticsSchema>;
